module.exports = __webpack_public_path__ + "img/bookmark-fill.dacdbc55.svg";